import React, { useState, useRef, useEffect } from "react";
import GoogleMapReact from "google-map-react";
import useSupercluster from "use-supercluster";
import styles from "./style.module.css";
import pointMarker from "../../Assets/Group 17999.png";
import API from "../../Config/API";
import eventMarker from "../../Assets/Event.png";
import serviceMarker from "../../Assets/Services.png";
import Modal from "react-bootstrap/Modal";
import ServicesCard from "../ServicesCard";
import PointsOfInterstCart from "../PointsOfInterstCart";

const Marker = ({ children }) => children;

function ModalComp({ show, setShow, value, type }) {
  const handleClose = () => setShow(false);
  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        centered={true}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          // padding: "10px",
        }}
      >
        <PointsOfInterstCart value={value} />
        {/* {type === "points" && */}
        {/* // (value?.points ? ( */}
        {/* // <PremiumPointsOfInterstCard value={value} /> */}
        {/* // ) : ( */}
        {/* ))} */}
        {/* {type === "events" && <EventsCard value={value} />} */}
        {type === "service" && <ServicesCard value={value} />}
      </Modal>
    </>
  );
}

export default function ClusterMarker() {
  const [data, setData] = useState();
  const mapRef = useRef();
  const [bounds, setBounds] = useState(null);
  const [zoom, setZoom] = useState(10);
  const [serviceData, setServiceData] = useState([]);
  const [currentUser, setCurrentUser] = useState("");
  const [currentLang, setCurrentLang] = useState("");
  const [show, setShow] = useState(false);
  const [value, setValue] = useState({});
  const [type, setType] = useState("");
  const [eventsData, setEventsData] = useState([]);
  const [currentLocation, setCurrentLocation] = useState("");

  const getPoints = () => {
    API.post("/get-points-web", {
      language: "Spanish",
    }).then((res) => setData(res?.data?.data));
  };
  const getEvents = async () => {
    try {
      let res;
      if (currentUser) {
        // API call for authenticated user
        res = await API.post("/get-events", { userId: currentUser?.id });
      } else {
        // API call for non-authenticated user
        res = await API.post("/get-events-web", {
          language: currentLang || "Spanish",
          lat: currentLocation?.latitude || "",
          long: currentLocation?.longitude || "",
        });
      }

      // Extract events and premium events from the response
      const events = res?.data?.data || [];
      const premiumEvents = res?.data?.premium;

      // Filter only the events with status "Active"
      const activeEvents = events.filter((event) => event.status === "Active");

      // Combine active events and active premium events into a single array
      const allEvents = [...activeEvents, ...premiumEvents];

      // Set the combined events to the "EventsData" state
      setEventsData(allEvents);
    } catch (error) {
      console.error(error);
    }
  };

  const getService = async () => {
    try {
      let res;
      if (currentUser) {
        res = await API.post("/get-services", { userId: currentUser?.id });
      } else {
        res = await API.post("/get-services-web", {
          language: currentLang || "Spanish",
          lat: currentLocation?.latitude || "",
          long: currentLocation?.longitude || "",
        });
      }

      const services = res?.data?.data || [];

      const activeServices = services.filter(
        (service) => service.status === "Active"
      );

      setServiceData(activeServices);
    } catch (error) {
      console.error(error);
    } finally {
      // setIsLoading(false);
      // setIsApiCallInProgress(false);
    }
  };

  const showPoints = async () => {
    try {
      let response = await API.post("/get-point-lang", {
        pointId: "495",
        language: "Spanish",
      });
      setValue(response.data.data);
      setShow(true);
      setType("point");
    } catch (error) {}
  };

  const pointsOfInterest = data ? data : [];
  const points = pointsOfInterest.map((crime) => ({
    type: "Feature",
    properties: {
      cluster: false,
      crimeId: crime.id,
      category: crime.categoryId,
    },
    geometry: {
      type: "Point",
      coordinates: [
        parseFloat(crime.points ? crime.points[0].longitude : crime.longitude),
        parseFloat(crime.points ? crime.points[0].latitude : crime.latitude),
      ],
    },
  }));

  const { clusters, supercluster } = useSupercluster({
    points,
    bounds,
    zoom,
    options: { radius: 75, maxZoom: 20 },
  });

  useEffect(() => {
    // Get User
    const user = localStorage.getItem("UserDetails");
    const parsedUser = JSON.parse(user);
    setCurrentUser(parsedUser);

    // Get Current Location
    const currentLocation = localStorage.getItem("currentLocation");
    const parsedLocation = JSON.parse(currentLocation);
    setCurrentLocation(parsedLocation);

    // Get Language
    const userLang = localStorage.getItem("userLanguage");
    setCurrentLang(userLang);
  }, []);

  useEffect(() => {
    getPoints();
    getService();
    getEvents();
  }, [zoom, bounds]);

  return (
    <>
      <ModalComp show={show} setShow={setShow} value={value} type={type} />

      <div style={{ height: "100vh", width: "100%" }}>
        <GoogleMapReact
          bootstrapURLKeys={{ key: "AIzaSyCPr-b3VlC4X08HU1jYqBPYeZrzt_Ci0SE" }}
          defaultCenter={{ lat: 39.21377454981294, lng: -3.4179556504347497 }}
          defaultZoom={5}
          yesIWantToUseGoogleMapApiInternals
          onGoogleApiLoaded={({ map }) => {
            mapRef.current = map;
          }}
          onChange={({ zoom, bounds }) => {
            setZoom(zoom);
            setBounds([
              bounds.nw.lng,
              bounds.se.lat,
              bounds.se.lng,
              bounds.nw.lat,
            ]);
          }}
        >
          {serviceData &&
            serviceData?.map((val) => {
              return (
                (val?.latitude || val?.longitude) && (
                  <Marker
                    key={val?.id}
                    lat={val?.latitude}
                    lng={val?.longitude}
                  >
                    <button
                      onClick={() => {
                        setValue(val);
                        setType("service");
                        setShow(true);
                      }}
                      className={styles.service_marker}
                    >
                      <img src={serviceMarker} alt="marker" />
                    </button>
                  </Marker>
                )
              );
            })}

          {eventsData &&
            eventsData?.map((val) => {
              return (
                (val?.latitude || val?.longitude) && (
                  <Marker
                    key={val?.id}
                    lat={val?.latitude}
                    lng={val?.longitude}
                  >
                    <button className={styles.service_marker}>
                      <img src={eventMarker} alt="marker" />
                    </button>
                  </Marker>
                )
              );
            })}

          {clusters.map((cluster) => {
            const [longitude, latitude] = cluster.geometry.coordinates;
            const { cluster: isCluster, point_count: pointCount } =
              cluster.properties;

            if (isCluster) {
              return (
                <Marker
                  key={`cluster-${cluster.id}`}
                  lat={latitude}
                  lng={longitude}
                >
                  <div
                    className={styles.cluster_marker}
                    style={{
                      width: `${10 + (pointCount / points.length) * 20}px`,
                      height: `${10 + (pointCount / points.length) * 20}px`,
                    }}
                    onClick={() => {
                      const expansionZoom = Math.min(
                        supercluster.getClusterExpansionZoom(cluster.id),
                        20
                      );
                      mapRef.current.setZoom(expansionZoom);
                      mapRef.current.panTo({ lat: latitude, lng: longitude });
                    }}
                  >
                    {pointCount}
                  </div>
                </Marker>
              );
            }

            return (
              <Marker
                key={`crime-${cluster.properties.crimeId}`}
                lat={latitude}
                lng={longitude}
              >
                <button
                  onClick={() => {
                    showPoints(cluster.properties.crimeId);
                  }}
                  className={styles.crime_marker}
                >
                  <img src={pointMarker} alt="marker" />
                </button>
              </Marker>
            );
          })}
        </GoogleMapReact>
      </div>
    </>
  );
}
